/**
 * Handles searching for defect codes
 * @param value 
 * @param filter 
 * @returns 
 */
export const customDefectCodeFilter = (value: string, filter: string) : boolean => {
    if (!filter || filter.trim() === '') {
        return true;
    }

    if (!value) {
        return false;
    }

    return value.toLowerCase().includes(filter.toLowerCase());
};